import {
  callApi,
  handleResponse,
  handleError,
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
} from '@helpers/api';

const getSavedFilingPeriodByIdRequest = agent => id => agent.get(`vFlow/savedFilingPeriod/${id}/`);

const getSavedFilingPeriodFileRequest =
  agent =>
  ({ id }) =>
    agent.get(`vFlow/savedFilingPeriodFile/${id}/`);

export const getSavedFilingFilePeriod = async payload =>
  callApi(getSavedFilingPeriodFileRequest)(payload).then(handleResponse).catch(handleError);

/** @deprecated */
export const getSavedFilingPeriodById = async id =>
  callApi(getSavedFilingPeriodByIdRequest)(id).then(handleResponse).catch(handleError);

/**
 * Fetch a list of filings
 * @param {Object} query Request filters
 * @param {number} query.limit Items per page
 * @param {number} query.offset Starting item index
 * @param {string} query.ordering Property to order by
 * @param {Array<string>} query.countries Country IDs to filter on
 * @param {Array<string>} query.taxable_jurisdictions Taxable jurisdiction IDs to filter on
 * @param {Array<string>} query.entities Entity IDs to filter on
 * @param {Array<string>} query.filing_types Filing type IDs to filter on
 * @param {Array<string>} query.filing_statuses Filing statuses to filter on
 * @param {string} query.date_start Date range filter start
 * @param {string} query.date_end Date range filter start
 * @param {string} query.stage ?
 * @param {string} query.user User ID to filter on
 * @returns {Promise<*>}
 */
export const getSavedFilingPeriodList = query => getRequest('vFlow/savedFilingPeriod/', query);

/**
 * Delete saved filing period file
 * @param {string} id - unique identifier
 * @returns {Promise<*>}
 */
export const deleteSavedFilingPeriodFile = id =>
  deleteRequest(`vFlow/savedFilingPeriodFile/${id}/`);

/**
 * Create Saved Filing Period.
 * @param {string} savedFilingPeriod
 * @param {string} category - saved filed period category.
 * @param {string} key - file upload key
 * @returns {Promise<*|Object>}
 */
export const createSavedFilingPeriod = ({ savedFilingPeriod, category, key }) =>
  postRequest('vFlow/savedFilingPeriodFile/', {
    saved_filing_period: savedFilingPeriod,
    category,
    key,
  });

/**
 * Get saved filing period by ID
 * @param {string} savedFilingPeriodId Saved Filing Period ID
 * @returns {Promise<*|Object>}
 */
export const fetchSavedFilingPeriod = savedFilingPeriodId =>
  getRequest(`vFlow/savedFilingPeriod/${savedFilingPeriodId}/`);

/**
 * Updates Saved Filing Period by id.
 * @param {string} id - Unique identifier.
 * @param {Object} data - Updated put data.
 * @returns {Promise<*|Object>}
 */
export const updateSavedFilingPeriodById = ({ id, data }) =>
  putRequest(`vFlow/savedFilingPeriod/${id}/`, data);

/**
 * Get a list of saved files, filter by filing period and categories
 * @param {Object} data - payload object
 * @param {string} data.id - saved filing period ID
 * @param {Array<string>} data.categories - saved filed period categories
 @returns {Promise<*|Object>}
 */
export const listSavedFilingPeriodFiles = ({ id, categories = [] }) =>
  getRequest(`vFlow/savedFilingPeriodFile/`, {
    saved_filing_period: id,
    category: categories,
  });

/**
 * Creates filing period correction
 * @param {string} id - Filing period id.
 */
export const createSavedFilingPeriodCorrection = id =>
  postRequest(`vFlow/createSavedFilingPeriodCorrection/${id}/`);
